/**
 * TaskReopenPromptModal
 *
 * Shown when a user submits a comment on a closed task. Posting re-opens the task —
 * the only alternative is to back out.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { getStatusLabel } from '../../configs/task.config';
import '../../styles/index.scss';

const TaskReopenPromptModal = ({
  visible,
  currentStatus,
  reopenStatus,
  loading,
  onReopen,
  onCancel,
}) => (
  <Modal
    className="task-create-modal"
    title="Re-open this task?"
    open={visible}
    onCancel={onCancel}
    closable={!loading}
    maskClosable={!loading}
    centered
    aria-labelledby="reopen-prompt-title"
    footer={[
      <Button key="cancel" onClick={onCancel} disabled={loading}>
        Cancel
      </Button>,
      <Button key="reopen" type="primary" onClick={onReopen} loading={loading}>
        Re-open &amp; Post
      </Button>,
    ]}
  >
    <p id="reopen-prompt-title">
      This task is already marked <strong>{getStatusLabel(currentStatus)}</strong>. Posting this
      comment will re-open it and set its status to <strong>{getStatusLabel(reopenStatus)}</strong>.
    </p>
  </Modal>
);

TaskReopenPromptModal.propTypes = {
  visible: PropTypes.bool,
  currentStatus: PropTypes.string,
  reopenStatus: PropTypes.string,
  loading: PropTypes.bool,
  onReopen: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

TaskReopenPromptModal.defaultProps = {
  visible: false,
  currentStatus: null,
  reopenStatus: null,
  loading: false,
};

export default TaskReopenPromptModal;
